import React from "react";

/* eslint-disable max-len */
function MoreIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g transform="translate(-1277 -743)">
                <rect width="40" height="40" rx="20" transform="translate(1277 743)" />
                <g transform="translate(928 23)">
                    <path d="M16,.5H0v-1H16Z" transform="translate(361 740)" fill="#fff" />
                    <path d="M.5,16h-1V0h1Z" transform="translate(369 732)" fill="#fff" />
                </g>
            </g>
        </svg>
    );
}

export default MoreIcon;
